<template>
  <div class="progress-bar" :class="cssType">
    <div class="progress-bar-inner">
      <div
        class="progress-bar-item"
        v-for="(item, index) in props.list" :key="item.id" :style="calcStyle(index)"
        :class="{ active: checkIsActive(item.needPurchaseCount, index), 'not-reach': props.rechargeDiamond < item.needPurchaseCount }"
      ></div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { defineProps } from 'vue'
import { isMobile } from '@/utils'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  rechargeDiamond: {
    type: Number,
    default: 0,
  },
  list: {
    type: Array,
    default: () => [],
  },
})
const checkIsActive = (diamond, index) => {
  const nextDiamond = props.list[index + 1]?.needPurchaseCount || Infinity
  if (props.rechargeDiamond >= diamond && props.rechargeDiamond < nextDiamond) {
    return true
  }
  return false
}
const calcStyle = (index) => {
  if (isMobile) {
    return {
      top: `${(index * 100 / (props.list.length - 1))}%`
    }
  }
  return {
    left: `${(index * 100 / (props.list.length - 1))}%`,
  }
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
